module.exports = "/images/collapse.svg?9456002ac8933b6fade4be1f8b0d7a68";